import { pipelineData } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

export interface PipelineParams {
  startDate?: Date | null
  endDate?: Date | null
  showCompleted?: boolean
  /**
   * Shown to the user as "Department" - the value in that column is the job's
   * worktype, so that is what the API filters on. Empty means no filter.
   */
  worktypeIds?: number[]
  projectManagerIds?: number[]
  /**
   * The Completed Jobs report: only jobs marked as complete, from its own
   * endpoint (secured by Reports.CompletedJobs). showCompleted is ignored.
   */
  completedOnly?: boolean
}

const toLocalDateString = (d: Date): string => {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getPipelineData = async (params?: PipelineParams): Promise<pipelineData[]> => {
  const token = localStorage.getItem('authToken')

  const query = new URLSearchParams()
  if (params?.startDate) query.set('startDate', toLocalDateString(params.startDate))
  if (params?.endDate) query.set('endDate', toLocalDateString(params.endDate))
  if (params?.showCompleted && !params?.completedOnly) query.set('showCompleted', 'true')

  // Repeated keys, which is what [FromQuery] List<int> binds from.
  params?.worktypeIds?.forEach((id) => query.append('worktypeIds', String(id)))
  params?.projectManagerIds?.forEach((id) => query.append('projectManagerIds', String(id)))

  const path = params?.completedOnly ? 'pipeline/completed' : 'pipeline'
  const url = `https://${apiURL}/${path}${query.toString() ? '?' + query.toString() : ''}`

  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch pipeline data')
  }
  
  const data = await response.json()
  return data
}